/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EquipmentIPCharges from './equipment-ip-charges';
import EquipmentIPChargesDetail from './equipment-ip-charges-detail';
import EquipmentIPChargesUpdate from './equipment-ip-charges-update';
import EquipmentIPChargesDeleteDialog from './equipment-ip-charges-delete-dialog';

const EquipmentIPChargesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EquipmentIPCharges />} />
    <Route path="new" element={<EquipmentIPChargesUpdate />} />
    <Route path=":id">
      <Route index element={<EquipmentIPChargesDetail />} />
      <Route path="edit" element={<EquipmentIPChargesUpdate />} />
      <Route path="delete" element={<EquipmentIPChargesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EquipmentIPChargesRoutes;
